/*eslint no-prototype-builtins: "off"*/
/* eslint-disable no-console */
import * as AccessGraphActionTypes from '../actionTypes/accessGraph.action.types'
import type { State } from '../configureStore'
import { defaultState } from '../reducers/access.graph/default.state'
import * as ReduxHelpers from '@src/utils/reduxHelpers'
import * as GraphHelpers from '@src/utils/graph.helpers'
import {
  autocompleteSearch,
  getAutoGenerateInput
} from '@src/utils/redux.tools'
import type { FilterAccount } from '../reducers/filter'

// Action Creators
export type ActionTypes =
  | getStatSuccessAction
  | getGraphStatSuccessAction
  | serverErrorsAction
  | requestPendingAction
  | requestPendingGraphAction

interface Graph {}
interface Errors {}

const getStatSuccess = ReduxHelpers.Common.Actions.setToState(
  AccessGraphActionTypes.GET_STAT_SUCCESS,
  defaultState
)
type getStatSuccessAction = ReturnType<typeof getStatSuccess>

export const getGraphStatSuccess = (graph: Graph) =>
  ReduxHelpers.Actions.createPayloadAction(
    AccessGraphActionTypes.GET_GRAPH_STAT_SUCCESS,
    {
      graph,
      isPending: false
    }
  )
type getGraphStatSuccessAction = ReturnType<typeof getGraphStatSuccess>

export const serverErrors = (errors: Errors) =>
  ReduxHelpers.Actions.createPayloadAction(
    AccessGraphActionTypes.SERVER_ERRORS,
    {
      errors,
      isPending: false
    }
  )
type serverErrorsAction = ReturnType<typeof serverErrors>

export const requestPending = (isPending: boolean) =>
  ReduxHelpers.Actions.createPayloadAction(
    AccessGraphActionTypes.REQUEST_PENDING,
    {
      isPending
    }
  )
type requestPendingAction = ReturnType<typeof requestPending>

export const requestPendingGraph = (isPending: boolean) =>
  ReduxHelpers.Actions.createPayloadAction(
    AccessGraphActionTypes.REQUEST_PENDING_GRAPH,
    {
      isPending
    }
  )
type requestPendingGraphAction = ReturnType<typeof requestPendingGraph>

export function startGetGraph() {
  return (dispatch: any, getStore: () => State) => {
    dispatch(requestPendingGraph(true))
  }
}

export function getGraphByView(callback: () => void) {
  return (dispatch: any, getStore: () => State) => {
    const { accessGraph, filter } = getStore()
    const { selectedGraphView } = accessGraph as {
      selectedGraphView: GraphHelpers.View
      usageBy?: number | null
    }
    const { currentAccount = {} as FilterAccount } = filter

    switch (selectedGraphView) {
      case GraphHelpers.View.usage:
      case GraphHelpers.View.crossAccount:
      case GraphHelpers.View.access:
      case GraphHelpers.View.privilege:
        return dispatch(
          autocompleteSearch({
            payload: {
              req_hdr: { tid: '1234' },
              input: getAutoGenerateInput({
                accountId: currentAccount?.id,
                selectedGraphView
              })
            },
            actionBefore: startGetGraph,
            actionSuccess: getGraphStatSuccess,
            actionError: serverErrors,
            showToastMessage: true,
            actionPending: requestPending,
            callback
          })
        )
      default:
        break
    }
  }
}

export function getGraph(data: string) {
  return (dispatch: any, getStore: () => State) => {
    const graph: Graph = data ? JSON.parse(data) : {}
    dispatch(getGraphStatSuccess(graph))
  }
}

export function changeGraphView(data: {
  selectedGraphView: GraphHelpers.View
  usageBy?: number | null
  callbackFn: () => void
  graphData?: string
}) {
  return (dispatch: any, getStore: () => State) => {
    dispatch(getStatSuccess('selectedGraphView', data.selectedGraphView))
    if (data.usageBy) dispatch(getStatSuccess('usageBy', data.usageBy))
    dispatch(getGraph(data.graphData))
  }
}
